import { css } from 'styled-components';
import {
  standardColours,
  brandColours,
  fontSize,
  brandFonts,
} from '../../utilities';

export const commonFormStyles = () => {
  return css`
    width: 100%;
    display: block;
    padding: 20px 16px;
    color: ${brandColours.secondary};
    ${fontSize(16)};
    background-color: ${standardColours.white};
    border: 1px solid ${brandColours.quinary};
    font-family: ${brandFonts.primary};
    appearance: none;
    border-radius: 0;
  `;
};
